import { z } from 'zod';

export const fixFormSchema = z.object({
  houseNumber: z.string(),
  category: z.union([
    z.object({
      name: z.enum(['家中設備', '其他'], {
        errorMap: () => {
          return { message: '請選擇類別' };
        },
      }),
      communityDeviceId: z.string().optional(),
    }),
    z.object({
      name: z.literal('公共設備'),
      communityDeviceId: z.string().min(1, '請選擇公共設備'),
    }),
  ]),
  title: z.string().min(1, '標題為必填欄位'),
  content: z.string().min(1, '內容為必填欄位').max(100, '內容最多100字'),
  bookingTime: z.string().min(1, '預約時間為必填欄位'),
  files: z.instanceof(FileList).optional(),
});

export type FixForm = z.infer<typeof fixFormSchema>;
